module.exports = {
      id: "protichinta-logo-usage",
      viewBox: "0 0 190 57.9",
      url: "/" + "sprite-819208feb9a4c8de23db7726a2e05315.svg#protichinta-logo",
      toString: function () {
        return this.url;
      }
    }